<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M5,9C5,9,4,9,4,9C4,9,4,10,4,10C4,10,5,10,5,10C5,10,5,9,5,9C5,9,5,9,5,9ZM15,0C15,0,1,0,1,0C0.45,0,0,0.45,0,1C0,1,0,14,0,14C0,14.55,0.45,15,1,15C1,15,4,15,4,15C4,15,4,16,4,16C4,16,6,15,6,15C6,15,8,16,8,16C8,16,8,15,8,15C8,15,15,15,15,15C15.55,15,16,14.55,16,14C16,14,16,1,16,1C16,0.45,15.55,0,15,0C15,0,15,0,15,0ZM4,13C4,13,2,13,2,13C2,13,2,12,2,12C2,12,4,12,4,12C4,12,4,13,4,13C4,13,4,13,4,13ZM14,13C14,13,8,13,8,13C8,13,8,12,8,12C8,12,14,12,14,12C14,12,14,13,14,13C14,13,14,13,14,13ZM14,11C14,11,3,11,3,11C3,11,3,2,3,2C3,2,14,2,14,2C14,2,14,11,14,11C14,11,14,11,14,11ZM5,3C5,3,4,3,4,3C4,3,4,4,4,4C4,4,5,4,5,4C5,4,5,3,5,3C5,3,5,3,5,3ZM5,7C5,7,4,7,4,7C4,7,4,8,4,8C4,8,5,8,5,8C5,8,5,7,5,7C5,7,5,7,5,7ZM5,5C5,5,4,5,4,5C4,5,4,6,4,6C4,6,5,6,5,6C5,6,5,5,5,5C5,5,5,5,5,5Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'GitRepo',
} as DefineComponent
</script>
